import {
  Credential,
  CredentialExistence,
  InfrastructureInputs,
  MigrationRequest,
  RequestColumnName,
  SortDirection,
  TestConnectionResponse,
  UserMappingValidation,
  ValidateInfrastructure
} from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { MigrationApiUri } from './uri';

export class MigrationApi {
  public static async saaSToOnpremMigrationDiscover(orgDetails: any) {
    const res = await Http.post(
      MigrationApiUri.SAAS_MIGRATION_DISCOVER(),
      orgDetails
    );
    return res.data;
  }

  public static async saaSToOnpremInProgressMigrationRequest(
    orgDetails: InfrastructureInputs
  ): Promise<ValidateInfrastructure> {
    const res = await Http.post(
      MigrationApiUri.SAAS_MIGRATION_VALIDATE(),
      orgDetails
    );
    return res.data;
  }

  public static async userMappingValidation(
    mappingValue: UserMappingValidation
  ): Promise<TestConnectionResponse> {
    const res = await Http.post(
      MigrationApiUri.USER_MAPPING_VALIDATE(),
      mappingValue
    );
    return res.data;
  }

  public static async createSaveMigrationRequest(request: MigrationRequest) {
    let res;
    if (request?.vmid) {
      res = await Http.patch(
        MigrationApiUri.CREATE_SAVE_MIGRATION_REQUEST(),
        request
      );
    } else {
      res = await Http.post(
        MigrationApiUri.CREATE_SAVE_MIGRATION_REQUEST(),
        request
      );
    }
    return res.data;
  }

  public static async saaSToOnpremMigrationPreCheck(userDetails: any) {
    const res = await Http.post(
      MigrationApiUri.SAAS_MIGRATION_PRECHECK(),
      userDetails
    );
    return res.data;
  }
  public static async createSaaSToOnpremMigration(request: MigrationRequest) {
    const res = await Http.post(
      MigrationApiUri.SUBMIT_MIGRATION_REQUEST(),
      request
    );
    return res.data;
  }
  public static async saaSToOnpremMigrationList(
    page: number,
    limit: number,
    sortBy?: RequestColumnName,
    sortByDirection?: SortDirection
  ) {
    const res = await Http.get(
      MigrationApiUri.SAAS_MIGRATION_LIST(page, limit, sortBy, sortByDirection)
    );
    return res.data;
  }

  public static async adaptersListRequest(requestId: string) {
    const res = await Http.get(
      MigrationApiUri.GET_ADAPTER_LIST_REQUEST(requestId)
    );
    return res.data;
  }

  public static async adaptersList(
    environmentId: string,
    contentEndpointId: string
  ) {
    const res = await Http.get(
      MigrationApiUri.ADAPTER_LIST(environmentId, contentEndpointId)
    );
    return res.data;
  }

  public static async migrationOverview(vmid: string) {
    const res = await Http.get(MigrationApiUri.MIGRATION_OVERVIEW(vmid));
    return res.data;
  }

  public static async removeMigrationRequest(vmid: string) {
    const res = await Http.delete(
      MigrationApiUri.DELETE_MIGRATION_REQUEST(vmid)
    );
    return res.data;
  }

  public static async contentsList(productId: string) {
    const res = await Http.get(MigrationApiUri.CONTENT_LIST(productId));
    return res.data;
  }

  public static async vrniSaasEndpointList(productId: string) {
    let url = MigrationApiUri.VROPS_SAAS_ENDPOINTS();
    if (productId === 'vra') {
      url = MigrationApiUri.VRA_SAAS_ENDPOINTS();
    } else if (productId === 'vrni') {
      url = MigrationApiUri.VRNI_SAAS_ENDPOINTS();
    } else if (productId === 'vrops') {
      url = MigrationApiUri.VROPS_SAAS_ENDPOINTS();
    }
    const res = await Http.get(url);
    return res.data;
  }

  public static async getEndpointContentList(
    endpointId: string,
    contentType: string,
    force?: boolean
  ) {
    const res = await Http.get(
      MigrationApiUri.ENDPOINT_CONTENT_LIST(endpointId, contentType, force)
    );
    return res.data;
  }

  public static async getContentCacheList(requestOutParameter: string) {
    const res = await Http.get(
      MigrationApiUri.CONTENT_CACHE_LIST(requestOutParameter)
    );
    return res.data;
  }

  public static async getContentRequest(requestId: string) {
    const res = await Http.get(MigrationApiUri.CONTENTS_REQUEST(requestId));
    return res.data;
  }

  public static async validateEndpointCredential(
    body: {
      id: string;
      endpointId: string;
      password: string;
    },
    contentType: string
  ) {
    const res = await Http.post(
      MigrationApiUri.VALIDATE_ENDPOINT_CREDENTIAL(contentType),
      body
    );
    return res.data;
  }

  public static async validateEndpointCredentials(payload: {
    contentCredentials: Credential[];
  }) {
    const res = await Http.post(
      MigrationApiUri.VALIDATE_ENDPOINT_CREDENTIALS_API_URL,
      payload
    );
    return res.data;
  }

  public static async getCredentialsExistForAccounts(
    accounts: {
      userName?: string;
      contentId: string;
    }[]
  ): Promise<CredentialExistence[]> {
    const res = await Http.post(
      MigrationApiUri.CREDENTIALS_EXISTENCE_API_URL,
      accounts
    );
    return res.data;
  }
}
